import React from "react";
import Verify2FA from "../components/Verify2FA";

const Verify2FAPage = () => {
  return (
    <>

      {/* SignInLayer */}
      <Verify2FA />

    </>
  );
};

export default Verify2FAPage;
